export default "__VITE_ASSET__B3WdaQQY__"